/**
 * Created by lzl on 19/05/21.
 * 第一步引入Share.js -> import Share from '../common/js/Share.lzl.js'
 * 第二步，调用分享 -> Share.shareModule(callback, [options])
 *
 * 单独定义钉钉分享数据 options = {
 *    dingding: {
 *      title: '钉钉分享标题',
 *      message: '钉钉分享副标题',
 *      imgUrl: '钉钉分享icon地址',
 *      url: '钉钉分享页面地址',
 *    }
 * }
 * 调用分享-> Share.shareModule((res)=>({console.log(res)})), options)
 *
 * 修改通用分享配置 即 修改config.share.js中的数据
 * options = {
 *    title: 'aaaa', // config.share.js 中的所有数据都可以覆盖
 * }
 * 调用分享-> Share.shareModule((res)=>({console.log(res)})), options)
 *
 * 注意：当更新涉及重新请求接口时请调用 Share.updateConfigParams(options)  即，重新获取服务配置的分享数据或重新获取口令分项数据
 * 注意修改时机，减少等待时间
 *
 * 注意：useServerConfig(使用服务配置数据分享)与useShareCommand(口令分享)配置互斥，只能其中一个为true。
 *
 * 端外二次分享时，只需引入文件，无需调用任何方法
 */
import CONFIGURL from './config.url';

export default {
  list: ['weixin', 'pengyou', 'dingding', 'weibo'], // 分享渠道
  hideMore: true, // 是否隐藏更多
  hideCopy: true, // 是否隐藏复制链接
  useServerConfig: false, // 是否使用服务下发配置
  addServerToShareLink: false, // 将从服务获得的参数放入分享url [title message imgUrl message]
  useShareCommand: false, // 使用口令分享 若配置请配置为 ==>> { biz_param: '' }
  shareType: 0, // 分享类型 0=url分享 1=图片分享 2=口令分享
  title: '分享标题', // 分享标题配置
  message: '', // 分享副标题
  imgUrl: 'https://gw.alicdn.com/tfs/TB1_FdyANnaK1RjSZFBXXcW7VXa-180-180.jpg', // 分享图片配置
  url: CONFIGURL.index, // 分享页面url
};
